"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M19.1183 18.3818L14.0774 13.3409C14.7429 12.5117 15.1052 11.48 15.1042 10.4167C15.1042 7.83205 13.0014 5.72925 10.4167 5.72925C7.83199 5.72925 5.72919 7.83205 5.72919 10.4167C5.72919 13.0014 7.83199 15.1042 10.4167 15.1042C11.4799 15.1053 12.5116 14.743 13.3408 14.0775L18.3817 19.1184C18.4301 19.1667 18.4875 19.2051 18.5507 19.2313C18.6139 19.2574 18.6816 19.2709 18.75 19.2709C18.8184 19.2709 18.8861 19.2574 18.9493 19.2313C19.0125 19.2051 19.0699 19.1667 19.1183 19.1184C19.1667 19.07 19.205 19.0126 19.2312 18.9494C19.2574 18.8862 19.2709 18.8185 19.2709 18.7501C19.2709 18.6817 19.2574 18.614 19.2312 18.5508C19.205 18.4876 19.1667 18.4302 19.1183 18.3818ZM10.4167 14.0626C9.69561 14.0626 8.99072 13.8488 8.39117 13.4481C7.79162 13.0475 7.32432 12.4781 7.04838 11.8119C6.77243 11.1458 6.70023 10.4127 6.84091 9.70548C6.98158 8.99826 7.32881 8.34863 7.83869 7.83875C8.34857 7.32888 8.9982 6.98164 9.70542 6.84097C10.4126 6.70029 11.1457 6.77249 11.8119 7.04844C12.4781 7.32438 13.0475 7.79168 13.4481 8.39123C13.8487 8.99079 14.0625 9.69567 14.0625 10.4167C14.0614 11.3833 13.677 12.3101 12.9935 12.9935C12.31 13.677 11.3833 14.0615 10.4167 14.0626Z",
    fill: props.foregroundColor
  }));
};

Search.defaultProps = {
  altText: "Search",
  foregroundColor: "#2D5AB4"
};
Search.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Search;
exports.default = _default;